import Button from '@material-ui/core/Button';
import { PropTypes } from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
import Cart from 'models/Cart';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import { SHOPPING_CART } from 'redux/domain/Cart/constants';
import React from 'react';
import CartItem from './CartItem';
import styles from '../styles.css';

const CartDisplay = props => {
	const { theme } = props;
	const {
		cart,
		isFetching,
		handleDelete,
		handleQuantityChange,
		totalItems,
		totalPrice,
		openEmailCart,
		cartType,
	} = props;

	// Only display on initial fetch. Otherwise we get flickering.
	if (isFetching && cart.items.length === 0) {
		return (
			<div>
				<IndeterminateCircularProgress size={60} />
			</div>
		);
	}

	return (
		<div className={styles['cart-flex-container']}>
			<div className={styles['cart-items-flex-item']}>
				{cart.items.length === 0 ? (
					<h4 className={styles['no-items']}>Add Items to Get Started</h4>
				) : (
					<div>
						{cartType === SHOPPING_CART ? (
							<div
								style={{
									textAlign: 'left',
									paddingLeft: '20px',
									position: 'sticky',
									margin: '10px',
									top: '10px',
								}}
							>
								<Button
									type="submit"
									style={{
										backgroundColor: theme.palette.primary.main,
										color: theme.palette.getContrastText(theme.palette.primary.main),
										'&:hover': { backgroundColor: theme.palette.primary.light },
									}}
									size="medium"
									onClick={openEmailCart}
								>
									Email Cart
								</Button>
							</div>
						) : null}

						<div>
							{cart.items.map(item => (
								<CartItem
									key={item.cartId}
									cartItem={item}
									handleDelete={handleDelete}
									handleQuantityChange={handleQuantityChange}
								/>
							))}
						</div>
					</div>
				)}
			</div>
			<div className={styles['total-flex-item']}>
				<div className={styles['total-info-container']}>
					<span>{`${totalItems} Items`}</span>
					<div className={styles['total-price-section']}>
						<span style={{ paddingRight: 10 }}>Subtotal:</span>
						<span style={{ color: theme.palette.secondary.main }}>{` $${totalPrice}`}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

CartDisplay.propTypes = {
	handleDelete: PropTypes.func.isRequired,
	handleQuantityChange: PropTypes.func.isRequired,
	cart: PropTypes.instanceOf(Cart).isRequired,
	isFetching: PropTypes.bool.isRequired,
	totalPrice: PropTypes.string.isRequired,
	totalItems: PropTypes.number.isRequired,
	theme: PropTypes.instanceOf(Object).isRequired,
	openEmailCart: PropTypes.func.isRequired,
	cartType: PropTypes.number.isRequired,
};

export default withTheme(CartDisplay);
